// Single source of truth for product keys, tier metadata, and Apple product IDs.
// Pages and modals MUST address products by `PRODUCT_KEYS`; the payment provider
// translates the key into the platform-specific identifier (Apple product ID on
// iOS, Stripe price ID on web). Keep this file in sync with the backend's
// APPLE_PRODUCT_MAP and the `id` values returned by GET /payments/products.

export const TIERS = {
  FREE: 'free',
  PREMIUM: 'premium',
  PREMIUM_PLUS: 'premium_plus',
};

export const PRODUCT_KEYS = {
  PREMIUM_MONTHLY: 'premium_monthly',
  PREMIUM_ANNUAL: 'premium_annual',
  PREMIUMPLUS_MONTHLY: 'premiumplus_monthly',
  PREMIUMPLUS_ANNUAL: 'premiumplus_annual',
  REMOVE_ADS: 'remove_ads',
  STARTER_PACK: 'starter_pack',
  UNDOS_10: 'undos_10',
  UNDOS_25: 'undos_25',
  BOMBS_10: 'bombs_10',
  BOMBS_25: 'bombs_25',
};

export const APPLE_PRODUCT_IDS = {
  premium_monthly: 'uk.co.wolftechnologies.blockblast.premium.monthly',
  premium_annual: 'uk.co.wolftechnologies.blockblast.premium.annual',
  premiumplus_monthly: 'uk.co.wolftechnologies.blockblast.premiumplus.monthly',
  premiumplus_annual: 'uk.co.wolftechnologies.blockblast.premiumplus.annual',
  remove_ads: 'uk.co.wolftechnologies.blockblast.removeads',
  starter_pack: 'uk.co.wolftechnologies.blockblast.starterpack',
  undos_10: 'uk.co.wolftechnologies.blockblast.undos.10',
  undos_25: 'uk.co.wolftechnologies.blockblast.undos.25',
  bombs_10: 'uk.co.wolftechnologies.blockblast.bombs.10',
  bombs_25: 'uk.co.wolftechnologies.blockblast.bombs.25',
};

export const APPLE_PRODUCT_TYPES = {
  premium_monthly: 'PAID_SUBSCRIPTION',
  premium_annual: 'PAID_SUBSCRIPTION',
  premiumplus_monthly: 'PAID_SUBSCRIPTION',
  premiumplus_annual: 'PAID_SUBSCRIPTION',
  remove_ads: 'NON_CONSUMABLE',
  starter_pack: 'NON_CONSUMABLE',
  undos_10: 'CONSUMABLE',
  undos_25: 'CONSUMABLE',
  bombs_10: 'CONSUMABLE',
  bombs_25: 'CONSUMABLE',
};

export function planProductKey(tier, period) {
  if (tier === TIERS.PREMIUM) {
    return period === 'annual' ? PRODUCT_KEYS.PREMIUM_ANNUAL : PRODUCT_KEYS.PREMIUM_MONTHLY;
  }
  if (tier === TIERS.PREMIUM_PLUS) {
    return period === 'annual' ? PRODUCT_KEYS.PREMIUMPLUS_ANNUAL : PRODUCT_KEYS.PREMIUMPLUS_MONTHLY;
  }
  return null;
}
